import {
  FORTA_BLACK,
  FORTA_BLUE,
  FORTA_GRAY3,
  FORTA_GRAY4,
  FORTA_WHITE,
} from '../../../../../../utils/colors';

export const DURATION_TRACKER_V2_CONTAINER_SX = {
  mt: 1,
  ml: { xs: 0, sm: 2 },
  width: { xs: '100%', sm: 'calc(100% - 16px)' },
  boxSizing: 'border-box',
  border: { xs: 0, md: `1px solid ${FORTA_GRAY3}` },
  borderRadius: { xs: 0, md: '12px' },
  backgroundColor: { xs: 'transparent', md: FORTA_WHITE },
  p: { xs: 0, md: 2 },
};

export const DURATION_TRACKER_V2_TOP_ROW_SX = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'max-content minmax(0, 1fr)',
    md: 'minmax(0, 1fr) minmax(180px, 260px)',
    lg: 'max-content minmax(180px, 260px) minmax(260px, 1fr) minmax(180px, 260px)',
  },
  columnGap: { xs: 1, md: 2 },
  rowGap: { xs: 2, md: 2 },
  alignItems: { xs: 'end', md: 'center' },
  justifyContent: 'stretch',
};

export const DURATION_TRACKER_V2_TITLE_SX = {
  color: FORTA_BLACK,
  fontSize: { xs: 15, sm: 16 },
  fontWeight: 700,
  lineHeight: 1.25,
  whiteSpace: 'nowrap',
};

export const RATE_TRACKER_V2_TITLE_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const DURATION_TRACKER_V2_TOTAL_FIELD_SX = {
  justifySelf: 'end',
  minWidth: 0,
  width: { xs: '100%', md: 260 },
  maxWidth: { xs: 205, md: 260 },
  minHeight: { xs: 52, md: 52 },
  '& .MuiTypography-root': {
    fontSize: { xs: 13, sm: 16 },
    whiteSpace: 'nowrap',
  },
};

export const DURATION_TRACKER_V2_ACTIONS_SX = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(2, minmax(0, 1fr))',
  },
  gap: { xs: 1.5, md: 2 },
  gridColumn: { xs: '1 / -1', md: 'auto' },
  minWidth: 0,
};

export const DURATION_TRACKER_V2_TIMER_FIELD_SX = {
  gridColumn: { xs: '1 / -1', md: 'auto' },
  justifySelf: { xs: 'center', md: 'stretch' },
  minWidth: 0,
  width: '100%',
  maxWidth: { xs: 250, md: 260 },
  '& .MuiTypography-root': {
    fontSize: { xs: 13, sm: 16 },
    whiteSpace: 'nowrap',
  },
};

export const DURATION_TRACKER_V2_WARNING_ROW_SX = {
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
  mt: 1,
};

export const DURATION_TRACKER_V2_EVENTS_GRID_SX = {
  display: { xs: 'grid', md: 'flex' },
  gridTemplateColumns: {
    xs: 'repeat(2, minmax(0, 1fr))',
  },
  flexWrap: 'wrap',
  columnGap: { xs: 1.5, md: 2 },
  rowGap: { xs: 1.25, md: 1.5 },
  mt: { xs: 2, md: 3 },
  '& > *': {
    width: { xs: '100%', md: 222 },
  },
};

export const DURATION_TRACKER_V2_BUTTON_SX = {
  minHeight: { xs: 44, md: 48 },
  borderRadius: '8px',
  px: { xs: 1, md: 3 },
  backgroundColor: FORTA_BLUE.primary,
  color: FORTA_WHITE,
  boxShadow: '0 4px 8px rgba(18, 78, 120, 0.25)',
  fontSize: { xs: 14, sm: 14 },
  fontWeight: 700,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: FORTA_BLUE.primary,
    boxShadow: '0 4px 8px rgba(18, 78, 120, 0.25)',
  },
  '&.Mui-disabled': {
    backgroundColor: FORTA_BLUE.light2,
    color: FORTA_WHITE,
  },
};

export const DURATION_TRACKER_V2_ADD_BUTTON_ROW_SX = {
  display: 'flex',
  justifyContent: 'flex-end',
  mt: { xs: 2.5, md: 4 },
};

export const DURATION_TRACKER_V2_ADD_BUTTON_SX = {
  ...DURATION_TRACKER_V2_BUTTON_SX,
  width: { xs: 'calc(50% - 8px)', md: 230 },
  minWidth: { xs: 0, md: 230 },
};

export const RATE_TRACKER_V2_TOP_ROW_SX = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'max-content minmax(0, 1fr)',
    md: 'max-content minmax(180px, 260px)',
  },
  columnGap: { xs: 1, md: 2 },
  rowGap: { xs: 2, md: 2 },
  alignItems: 'center',
};

export const RATE_TRACKER_V2_TOTAL_FIELD_SX = {
  justifySelf: 'end',
  minWidth: 0,
  width: { xs: '100%', md: 260 },
  maxWidth: { xs: 205, md: 260 },
  minHeight: { xs: 52, md: 52 },
  '& .MuiTypography-root': {
    fontSize: { xs: 13, sm: 16 },
    whiteSpace: 'nowrap',
  },
};

export const RATE_TRACKER_V2_EVENTS_GRID_SX = {
  ...DURATION_TRACKER_V2_EVENTS_GRID_SX,
};

export const RATE_EVENT_FIELD_SX = {
  minHeight: { xs: 42, md: 46 },
  px: { xs: 0.5, md: 1 },
  py: 0,
};

export const RATE_EVENT_FIELD_TEXT_SX = {
  color: FORTA_GRAY4,
  fontSize: { xs: 12, sm: 16 },
  fontWeight: 500,
  lineHeight: 1.25,
  textAlign: 'center',
  whiteSpace: 'nowrap',
};

export const RATE_EVENT_EDIT_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  width: { xs: '100%', md: 222 },
  minWidth: 0,
};

export const RATE_EVENT_EDIT_FIELD_SX = {
  minHeight: { xs: 42, md: 46 },
  px: { xs: 0.5, md: 1 },
  py: 0,
};

export const RATE_EVENT_DELETE_BUTTON_SX = {
  color: FORTA_BLUE.primary,
  p: 0,
  '&.Mui-disabled': {
    color: FORTA_GRAY3,
  },
};

export const DURATION_TRACKER_V2_LINK_SX = {
  display: { xs: 'inline-flex', md: 'none' },
  mt: 2,
  fontSize: 16,
  fontWeight: 700,
  cursor: 'pointer',
  color: FORTA_BLUE.bright,
  '&:hover': {
    color: FORTA_BLUE.primary,
  },
};

export const DURATION_EVENT_FIELD_SX = {
  minHeight: { xs: 42, md: 46 },
  px: { xs: 0.5, md: 1 },
  py: 0,
};

export const DURATION_EVENT_EDITING_FIELD_SX = {
  minHeight: 88,
  px: 1,
};

export const DURATION_EVENT_FIELD_TEXT_SX = {
  color: FORTA_GRAY4,
  fontSize: { xs: 12, sm: 16 },
  fontWeight: 500,
  lineHeight: 1.25,
  textAlign: 'center',
  whiteSpace: 'nowrap',
};

export const DURATION_EVENT_STEPPER_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 0.5,
  width: '100%',
};

export const DURATION_EVENT_UNIT_SX = {
  minWidth: 38,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const DURATION_EVENT_VALUE_SX = {
  color: FORTA_GRAY4,
  fontSize: 16,
  fontWeight: 500,
  lineHeight: 1.1,
  whiteSpace: 'nowrap',
};

export const DURATION_EVENT_ICON_BUTTON_SX = {
  p: 0,
  color: FORTA_BLUE.primary,
  '&.Mui-disabled': {
    color: FORTA_GRAY3,
  },
};

export const DURATION_EVENT_DELETE_BUTTON_SX = {
  ...DURATION_EVENT_ICON_BUTTON_SX,
  ml: 0.5,
};

export const DURATION_TRACKER_V2_EMPTY_SX = {
  mt: 2,
  textAlign: 'left',
};
